import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, lastValueFrom, Observable, of } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';

import { ConfigService } from '@docma-mm-core/config/config.service';
import {Project} from '@docma-mm-core/project/project';
import { BpPin } from '../../bp-common/models/bp-pin';


@Injectable()
export class PinService extends BasedataService {


  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }


  // get bp-pins by project
  public async getProjectPins(project: Project): Promise<BpPin[]> {
    try {
      if (!project?.MyDocmaUid) {
        console.warn('[PinService] Cannot load pins: project.MyDocmaUid is missing');
        return [];
      }

      const url = this.getFullUrl(`/projects/${project.MyDocmaUid}/coordinates`);
      const pins = await lastValueFrom(
        this.http.get<BpPin[]>(url, { headers: this.getHeaders() }).pipe(
          catchError(error => {
            console.error('[PinService] Error loading project pins:', error);
            return of([]);
          })
        )
      );
      return pins || [];
    } catch (error) {
      console.error('[PinService] Unexpected error in getProjectPins:', error);
      return [];
    }
  }



}
